module.exports = __webpack_public_path__ + "img/ctrip.7125a239.jpg";